import { Box, Dialog, ModalProps, Slide } from "@mui/material";
import clsx from "clsx";
import {
  FunctionComponent,
  PropsWithChildren,
  ReactNode,
  type JSX,
} from "react";
import "./styles.scss";

export type MobilePopoverCardDirection = "up" | "down" | "left" | "right";

export interface IMobilePopoverCardProps {
  id?: string;
  role?: string;
  open: boolean;
  className?: string;
  scroll?: "body" | "paper";
  contentClassName?: string;
  direction?: MobilePopoverCardDirection;
  fullScreen?: boolean;
  // note: when fullScreen!==true, the PopoverCard will be centered horizontally if centered===true
  centered?: boolean;
  headerElement?: JSX.Element | string;
  topLeftButton?: JSX.Element;
  topRightButton?: JSX.Element;
  bottomButton?: JSX.Element;
  onClose?: ModalProps["onClose"];
  fullScreenWithBanner?: boolean;
  disableEnforceFocus?: boolean;
  children?: ReactNode;
  scrollableContainerRef?: React.RefObject<HTMLElement | null>;
  paperClassName?: string;
}

export const MobilePopoverCard: FunctionComponent<IMobilePopoverCardProps> = ({
  id,
  role,
  open,
  onClose,
  className,
  contentClassName,
  direction,
  children,
  fullScreen,
  centered = true,
  headerElement,
  topLeftButton,
  topRightButton,
  bottomButton,
  fullScreenWithBanner,
  disableEnforceFocus,
  scrollableContainerRef,
  paperClassName = "",
}: PropsWithChildren<IMobilePopoverCardProps>) => (
  <Dialog
    id={id}
    role={role}
    hideBackdrop={false}
    BackdropProps={{
      invisible: false,
    }}
    open={open}
    onClose={onClose}
    TransitionComponent={Slide}
    classes={{ paper: paperClassName }}
    TransitionProps={{
      // See https://mui.com/material-ui/transitions/#performance-amp-seo
      unmountOnExit: true,
      /* eslint-disable */
      // @ts-ignore: Fix the type definition of TransitionProps to include direction.
      direction: direction ?? "up",
      /* eslint-enable */
    }}
    className={clsx("mobile-popover-card-root", className, {
      "full-screen": fullScreen,
      centered,
      "full-screen-banner": fullScreenWithBanner,
    })}
    disableEnforceFocus={disableEnforceFocus}
    paperfullscreen={fullScreen ? "true" : "false"}
  >
    <Box className="mobile-popover-card-container">
      <Box className="mobile-popover-card-header-container">
        <Box className={clsx("mobile-popover-card-top-button", "left")}>
          {topLeftButton}
        </Box>
        {headerElement && (
          <Box className="mobile-popover-card-header">{headerElement}</Box>
        )}
        <Box className={clsx("mobile-popover-card-top-button", "right")}>
          {topRightButton}
        </Box>
      </Box>
      <Box
        ref={scrollableContainerRef}
        className={clsx(
          "mobile-popover-card-content-container",
          contentClassName
        )}
      >
        {children}
      </Box>
      {bottomButton && (
        <Box className="mobile-popover-card-bottom-button">{bottomButton}</Box>
      )}
    </Box>
  </Dialog>
);
